// extracted by mini-css-extract-plugin
export default {"statusContainer":"TermsAndConditionAgreementStatus_statusContainer__xFGCF","currentStatus":"TermsAndConditionAgreementStatus_currentStatus__FWOhW"};